import React from "react"
import { createPortal } from "react-dom"

import { useSearchspringSearchContext } from "@app/scripts/providers/searchspring"
import { useSearchspringFilters } from "@app/scripts/hooks/use-searchspring-filters"

import { FilterSortDrawerActiveItems } from "@app/scripts/components/filter-sort-drawer-active-items"
import { FilterSortDrawerFilterSort } from "@app/scripts/components/filter-sort-drawer-filter-sort"
import { FilterSortDrawerFooter } from "@app/scripts/components/filter-sort-drawer-footer"
import { useSearchspringSort } from "@app/scripts/hooks/use-searchspring-sort"

export function FilterSortDrawer() {
  const { response } = useSearchspringSearchContext()
  const { activeFilters, handleToggleFilter, handleClearFilters } =
    useSearchspringFilters()
  const { sorts, activeSortLabel } = useSearchspringSort()

  const drawerRoot =
    typeof window !== "undefined"
      ? document.getElementById("filter-sort-drawer-root")
      : null

  if (!response || !drawerRoot) return null

  const filterSortData = [
    {
      label: "Sort By",
      field: "sort_by",
      activeSort: activeSortLabel,
      values: sorts,
    },
    ...response.facets,
  ]

  const drawerContent = (
    <div className="ss-filter-sort-drawer">
      <FilterSortDrawerActiveItems />
      <FilterSortDrawerFilterSort
        filterSortData={filterSortData}
        handleToggleFilter={handleToggleFilter}
        activeFilters={activeFilters}
      />
      <FilterSortDrawerFooter
        handleClearFilters={handleClearFilters}
        resultCount={response?.pagination?.totalResults}
      />
    </div>
  )

  return createPortal(drawerContent, drawerRoot)
}
